import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class CacheBustingInterceptor implements HttpInterceptor {
  
  private readonly cacheBustingPatterns = [
    /\/assets\/i18n\/.*\.json$/
  ];

  private readonly buildHash = this.generateBuildHash();

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.shouldApplyCacheBusting(req.url)) {
      const cacheBustedReq = req.clone({
        setParams: {
          'v': this.buildHash
        }
      });
      
      return next.handle(cacheBustedReq);
    }
    
    return next.handle(req);
  }

  private shouldApplyCacheBusting(url: string): boolean {
    return this.cacheBustingPatterns.some(pattern => pattern.test(url));
  }

  private generateBuildHash(): string {
    const buildInfo = environment.version || '1.0.0';
    const buildTime = environment.buildTimestamp || Date.now().toString();
    
    let hash = 0;
    const str = buildInfo + buildTime;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash;
    }
    return Math.abs(hash).toString(36);
  }
}
